import Collapse from '@material-ui/core/Collapse';
import classNames from 'clsx';
import React, { useState } from 'react';

import Arrow from '@swf/first/assets/icons/green-arrow.svg';

import PaymentMethodLogo from '../../../../../PaymentMethodLogo/PaymentMethodLogo';

import {
  active,
  arrow,
  container,
  paymentIcon,
  paymentInfo,
  paymentName,
  paymentWrapper,
  wrapper,
  wrapperInner
} from './CollapsiblePayment.scss';

interface Props {
  children: React.ReactElement;
  i18nSystemName: string;
  type: number;
}

const CollapsiblePayment: React.FC<Props> = ({ children, i18nSystemName, type }) => {
  const [expand, setExpand] = useState(false);

  return (
    <div data-testid="payment-wrapper" className={wrapper} onClick={() => setExpand(!expand)}>
      <div className={paymentWrapper}>
        <div className={paymentInfo}>
          <PaymentMethodLogo cardType={type} i18nSystemName={i18nSystemName} variant="result" />
          <span className={paymentName}>{i18nSystemName}</span>
        </div>
        <div className={paymentIcon}>
          <Arrow className={classNames(arrow, { [active]: expand })} />
        </div>
      </div>
      <Collapse classes={{ root: container, wrapperInner }} in={expand}>
        {children}
      </Collapse>
    </div>
  );
};

CollapsiblePayment.displayName = 'CollapsiblePayment';

export default CollapsiblePayment;
